import { COLORS } from '../../../../../../../../common/Styleguide/Common/colors';

export const submissionTabMetricsTabsStyle = {
  mt: '-20px',
  ml: '-20px',
  p: '20px',
  width: 'calc(100% + 40px)',
  backgroundColor: COLORS.black[70],
  '& > div': {
    overflowX: 'auto !important',
  },
  '& > div > .MuiTabs-indicator': {
    display: 'none',
  },
  '& > div > div': { display: 'flex', flexDirection: 'row', columnGap: '12px' },
};

export const submissionTabMetricsTabStyle = {
  fontSize: '18px',
  fontWeight: 700,
  textTransform: 'none',
  color: COLORS.white[40],
  backgroundColor: COLORS.black[90],
  borderRadius: '30px',
  boxShadow: 'none !important',
  '&.Mui-selected': {
    backgroundColor: COLORS.brand[100],
    color: COLORS.white[100],
  },
};
